var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Router } from '@angular/router';
import { SessionStorageService, SessionStorage } from '../jng2-webstorage/app';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApplicationService } from '../application/application.service';
import { ConfigService } from '../config/config.service';
var UserService = /** @class */ (function () {
    function UserService(appService, storage, router, configService, sessionService) {
        this.appService = appService;
        this.storage = storage;
        this.router = router;
        this.configService = configService;
        this.sessionService = sessionService;
        this.UserSubject = new BehaviorSubject(null);
        this.UserSubject.next(this._User);
    }
    Object.defineProperty(UserService.prototype, "User", {
        get: function () {
            return this._User;
        },
        set: function (_ui) {
            this._User = _ui;
            this.UserSubject.next(_ui);
        },
        enumerable: true,
        configurable: true
    });
    // #region Clear User Service Call
    UserService.prototype.ClearUser = function () {
        this.User = null;
        // this.sessionService.clear();
        this.sessionService.clear('_User');
        // Clear out all session specific settings.
        this.appService.CurrentSchool = null;
        this.sessionService.clear('_currentschool');
        this.appService.SelectedSchoolYear = null;
        this.sessionService.clear('_selectedschoolyear');
        this.appService.SelectedStudent = null;
        this.sessionService.clear('_selectedstudent');
    };
    // #endregion
    // #region Set User Service Call
    UserService.prototype.SetUser = function (user) {
        var currole = this.User && this.User.CurrentRole;
        user.CurrentRole = currole;
        this.User = user;
    };
    // #endregion
    // #region Set User Current Role Service Call
    UserService.prototype.SetUserCurrentRole = function (role) {
        if (this.User.CurrentRole != null && role === this.User.CurrentRole) {
            return;
        }
        // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing User object.
        var newUser = JSON.parse(JSON.stringify(this.User));
        // Update the current role field.
        newUser.CurrentRole = role;
        // Update the "current role" bit flags based upon the role in place right now
        newUser.IsAdvisor = role === 'Advisor';
        newUser.IsCollegeAdmin = role === 'CollegeAdmin';
        newUser.IsCollegeSupport = role === 'CollegeSupport';
        newUser.IsCounselor = role === 'Counselor';
        newUser.IsDeveloper = role === 'Developer';
        newUser.IsDistrictAdmin = role === 'DistrictAdmin';
        newUser.IsDistrictUser = role === 'DistrictUser';
        newUser.IsParent = role === 'Parent';
        newUser.IsSchoolAdmin = role === 'SchoolAdmin';
        newUser.IsStudent = role === 'Student';
        newUser.IsMultiRole = newUser.Roles.IsMultiRole;
        // Now, persist it to session storage and then broadcast it for listeners.
        this.User = newUser;
        // Go to the home screen for this role.
        var homeroute = '/home';
        this.router.navigate([homeroute]);
    };
    // #endregion
    // #region Update AuthToken Service Call
    UserService.prototype.UpdateAuthToken = function (AuthToken) {
        // If the authtoken has changed, update the user record.
        if (AuthToken !== this.User.AuthToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing
            // User object.
            var newUser = __assign({}, this.User);
            // Update the AuthToken field
            newUser.AuthToken = AuthToken;
            // Now, persist it to session storage and then broadcast it for listeners
            this.User = newUser;
        }
    };
    __decorate([
        SessionStorage(),
        __metadata("design:type", UserInfo)
    ], UserService.prototype, "_User", void 0);
    return UserService;
}());
export { UserService };
// #region Custom Classes
var UserInfo = /** @class */ (function () {
    function UserInfo() {
    }
    return UserInfo;
}());
export { UserInfo };
var UserRole = /** @class */ (function () {
    function UserRole() {
    }
    return UserRole;
}());
export { UserRole };



// WEBPACK FOOTER //
// ./src/services/user/user.service.ts.pre-build-optimizer.js